module.exports = __webpack_public_path__ + "static/img/bridges02.377247b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/blog/bridges02.jpg
// module id = KI4z
// module chunks = 0